class CategoryHeaderSmallFormatController {
    constructor($scope, $element, $state, categoriesService, moveFocus) {
        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.categoriesService = categoriesService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.open = false;

        this.categoriesService.getAll();

        this.$scope.$on('$stateChangeStart', () => this.closeMenu());
    }

    get rootCategory() {
        return this.categoriesService.rootCategory;
    }

    get currentCategory() {
        return this.selectedCategories.current || this.rootCategory;
    }

    onSelectCategory(category) {
        this.selectedCategories.pushCategory(category);
        this.moveFocus('#categoryHeaderSmallFormat-browseButton');
        this.fixIOSMomentumScrolling();
    }

    onBack() {
        this.selectedCategories.popCategory();
        this.fixIOSMomentumScrolling();
    }

    toggleOpen() {
        this.open = !this.open;
        if (this.open) {
            // Set selected categories
            this.selectedCategories = this.categoriesService.currentCategories.clone();
            // Navigate to the parent category
            this.onBack();
        }
    }

    closeMenu() {
        if (this.open) {
            this.toggleOpen();
        }
    }

    /**
     * On iOS, if the content of a scrollable container with -webkit-overflow-scrolling: scroll
     * is shorter than the height of the container (causing it to not be scrollable) and then
     * changes to become taller (causing it to be scrollable) Safari will not realise this and
     * the container will not be scrollable. This happens when going from a short list of categories
     * to a long list of categories.
     *
     * The fix is to toggle this property to get Safari to check the container again and apply scrolling to it.
     */
    fixIOSMomentumScrolling() {
        this.$element.find('.categoryHeaderSmallFormat-list').css('-webkit-overflow-scrolling', 'auto');
        setTimeout(() => this.$element.find('.categoryHeaderSmallFormat-list').css('-webkit-overflow-scrolling', 'touch'));
    }
}

const categoryHeaderSmallFormatComponentDefinition = {
    controller: ['$scope', '$element', '$state', 'CategoriesService', 'MoveFocus', CategoryHeaderSmallFormatController],
    template: require('./category-header-small-format.component.html').trim(),
};

module.exports = {
    CategoryHeaderSmallFormatController,
    categoryHeaderSmallFormatComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/category-header-small-format.component.js